module.exports = __webpack_public_path__ + "static/media/extension.5fea7a46.jpg";